import { cmsSimplePageRoutePath } from '@bcf-v2/routes-statics/common/app/paths/cms-simple-page-route-path';
import { SpSidebarLink } from '../types';

export const spSidebarLinksFn = (): SpSidebarLink[] => [
  {
    url: cmsSimplePageRoutePath('terms-and-conditions'),
    title: $localize`Terms and conditions`
  },
  {
    url: cmsSimplePageRoutePath('responsible-gaming'),
    title: $localize`Responsible gaming`
  },
  {
    url: cmsSimplePageRoutePath('terms-promotion-and-bonus'),
    title: $localize`Bonus terms`
  },
  {
    url: cmsSimplePageRoutePath('terms-for-each-sport'),
    title: $localize`Special Rules for Sport`
  },
  {
    url: cmsSimplePageRoutePath('privacy-policy'),
    title: $localize`Privacy Policy`
  },
  {
    url: cmsSimplePageRoutePath('about-us'),
    title: $localize`About us`
  }
];
